var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMonitor = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.394,
    height: 16.394,
    viewBox: "0 0 16.394 16.394",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.394,40H4v1.464a.878.878,0,0,0,.878.878H19.515a.878.878,0,0,0,.878-.878Zm-8.2,2.049a.878.878,0,1,1,.878-.878A.878.878,0,0,1,12.2,42.049Z",
    transform: "translate(0 -25.461)",
    fill: "#09819a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cy: 0.5,
    ry: 0.5,
    transform: "translate(12 15.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.2,58.293A.293.293,0,0,0,25.9,58H18.293a.293.293,0,0,0-.293.293v.293h8.2Z",
    transform: "translate(-9.902 -38.192)",
    fill: "#09819a"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.394,4.878A.878.878,0,0,0,19.515,4H4.878A.878.878,0,0,0,4,4.878v9.075H20.394Z",
    fill: "#09819a"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.1,50l-.659,1.756h5.01L27.794,50Z",
    transform: "translate(-13.751 -32.534)",
    fill: "#09819a"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMonitor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/monitor.8fd39c7d.svg";
export { ForwardRef as ReactComponent };